import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/axiosAuth";

export const fetchWHWarehouses = createAsyncThunk(
  "api/WHWarehouses/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`/api/WHWarehouses`);
      return { rows: response.data || [] };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const WHWarehousesSlice = createSlice({
  name: "WHWarehouses",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWHWarehouses.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchWHWarehouses.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload.rows;
      })
      .addCase(fetchWHWarehouses.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default WHWarehousesSlice.reducer;
export const selectWHWarehousesRows = (state) => state.WHWarehouses.rows;
export const selectWHWarehousesStatus = (state) => state.WHWarehouses.status;
export const selectWHWarehousesError = (state) => state.WHWarehouses.error;
